module.exports = __webpack_public_path__ + "static/media/socialPiper-schedule-mobile-en.559635af.png";